import { EHelpTextVariant, HelpText } from '@outdoorsyco/bonfire';
import React from 'react';

import css from './BillModuleMessage.module.css';

export { EHelpTextVariant as EBillModuleMessageType } from '@outdoorsyco/bonfire';

interface BillModuleMessageProps {
  message: string;
  type: EHelpTextVariant;
  className?: string;
}

const BillModuleMessage: React.FC<BillModuleMessageProps> = ({ message, type, className = '' }) => {
  return (
    <div
      data-testid={`bill-message-${type}`}
      className={`py-2 ${css.messageContainer} ${className}`}
      data-type={type}>
      <HelpText text={message} variant={type} showIcon />
    </div>
  );
};

export default BillModuleMessage;
